var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMwc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.621 17.897a2.122 2.122 0 0 1 .001-3L6.898 9.62a2.122 2.122 0 0 1 3 .001l5.276 5.277.079.083h1.496c.026-.028.052-.056.08-.083l5.275-5.276a2.122 2.122 0 0 1 3 .001l5.276 5.277a2.122 2.122 0 0 1-.001 3l-5.277 5.276a2.122 2.122 0 0 1-3 0l-5.276-5.276a2.15 2.15 0 0 1-.2-.23h-1.255c-.06.08-.126.158-.2.23l-5.275 5.276a2.122 2.122 0 0 1-3 0L1.62 17.897z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMwc);
export default __webpack_public_path__ + "static/media/MWC.52a56b7216a15b8b054437b8c04b9f12.svg";
export { ForwardRef as ReactComponent };